var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Page(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 658.304,
    height: 509.881,
    viewBox: "0 0 658.304 509.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID",
    cx: 4.711,
    cy: 8.524,
    rx: 4.711,
    ry: 8.524,
    transform: "translate(677.663 191.965)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M712.258,192.574c10.419,1.78,10.419,15.194,0,16.973a2.683,2.683,0,0,1-.885,0c-10.419-1.779-10.419-15.193,0-16.973A2.682,2.682,0,0,1,712.258,192.574Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404page.svg",
    "data-name": "404page.svg",
    transform: "translate(-353.848 -126.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Page_not_found",
    "data-name": "Page not found",
    transform: "translate(602.633 629.434)",
    fill: "#7b7b7b",
    fontSize: 21,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Page not found")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M668.386,269.563l-.838-26.214s5.208,23.99,32.484,23.678c26.067-.3,25.591-21.136,25.591-21.136l.93,10.565v42.68l-17,69.624-21.712,2.754-24-95.173Z",
    fill: "#e4ebf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M723.2,261.173a2.735,2.735,0,0,1-.314.558,14.963,14.963,0,0,1-1.033,1.52,22.4,22.4,0,0,1-4.856,4.7,27.937,27.937,0,0,1-9.07,4.259,32.022,32.022,0,0,1-12.235.846,39.869,39.869,0,0,1-11.753-3.537,51.006,51.006,0,0,1-8.585-5.173,59.4,59.4,0,0,1-5.2-4.307c-.591-.534-1.019-.983-1.317-1.276a2.792,2.792,0,0,1-.43-.476,2.789,2.789,0,0,1,.506.394l1.385,1.2c1.2,1.037,2.979,2.5,5.286,4.15a53.313,53.313,0,0,0,8.571,5.027,40.3,40.3,0,0,0,11.607,3.45,32.115,32.115,0,0,0,12.032-.79,28.251,28.251,0,0,0,8.974-4.085,23.807,23.807,0,0,0,4.913-4.512C722.673,261.886,723.148,261.14,723.2,261.173Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M704.269,484.935l-.393-123.722-35.134-90.3-1.181-27.175-21.408,16.191S614.982,367.21,614.5,363.491s-.011,121.444-.011,121.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M703.425,484.592c-.153,0-.278-27.879-.278-62.261s.125-62.267.278-62.267.279,27.872.279,62.267S703.579,484.592,703.425,484.592Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M646.466,277.6l4.345,3.289-3.055,20.015,51.287,53.719-46.581-61.167,3.97-15.857Z",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M706.192,422.624l-78.706-23.077-2.607-59.782L646.466,261s-51.457,25.672-54.958,42.008-11.942,56.049-12.842,84.752c-.8,25.665-.921,42.824,4.939,51.015,16.784,23.462,127.389,27.652,171.577-.033",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M700.032,355.928a2.024,2.024,0,0,1-.256-.289l-.707-.882-2.673-3.425-9.75-12.656-32-41.884-2.408-3.162-.081-.106.032-.13c1.376-5.478,2.708-10.789,3.98-15.854l.26.333-9.965-.014h-.255v-.254c.016-6.475.03-12.412.042-17.672v-.106l.083-.063L661.8,248.009l4.246-3.187,1.116-.818a2.545,2.545,0,0,1,.394-.262,2.768,2.768,0,0,1-.355.312l-1.079.867L661.95,248.2l-15.355,11.9.083-.169c.013,5.26.027,11.2.042,17.672l-.254-.255,9.965-.013h.343l-.083.334c-1.266,5.067-2.592,10.379-3.96,15.859l-.049-.236q1.2,1.568,2.409,3.162l31.868,41.982,9.609,12.764,2.591,3.488.662.915A2.01,2.01,0,0,1,700.032,355.928Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M735.119,255.277c-6.278-10.978-9.534-9.836-9.534-9.836l.328,3.913.006,8.223-2.974,35.278-19.069,76.659.393,115.421h72.08l8.972-140.894-.815-60.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M784.506,283.345s18.658,13.774,20.274,35.931c1.312,18,4.325,67.278,4.869,78.007.849,16.708-12.161,55.831-46.033,44.749-20.311-6.646-95.36-32.156-95.36-32.156l4.993-31.871,89.076,5.306,1.769-74.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M735.119,255.277c-6.278-10.978-9.534-9.836-9.534-9.836l.328,3.913.006,8.223-2.974,35.278-19.069,76.659.393,115.421h72.08l8.972-140.894-.815-60.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M784.506,283.345s18.658,13.774,20.274,35.931c1.312,18,4.325,67.278,4.869,78.007.849,16.708-12.161,55.831-46.033,44.749-20.311-6.646-95.36-32.156-95.36-32.156l4.993-31.871,89.076,5.306,1.769-74.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M672.234,381.675s-25.211-2.726-31.051-1.316c-5.611,1.354-13.6,8.219-13.6,8.219l.113,9.961,40.561,11.337Z",
    fill: "#f7eae8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M703.876,357.99a1.727,1.727,0,0,1,.111-.343l.379-.985c.358-.895.864-2.157,1.508-3.768l5.642-13.815,8.433-20.463c.8-1.917,1.591-3.917,2.582-5.871.95-1.974,2.072-3.907,3.229-5.863a128.757,128.757,0,0,1,8.005-11.553c1.454-1.877,2.92-3.7,4.436-5.454l-.05.284q-1.6-4.08-3.14-7.987l-.1-.265.27-.092,13.139-4.466-.135.367-14.9-24.872c-1.8-3.018-3.343-5.428-4.976-6.419a6.572,6.572,0,0,0-1.993-.807c-.479-.116-.732-.159-.729-.177a5.446,5.446,0,0,1,.747.1,6.223,6.223,0,0,1,2.058.75,9.041,9.041,0,0,1,2.527,2.451,44.421,44.421,0,0,1,2.62,3.941l15.076,24.778.162.266-.3.1-13.127,4.5.165-.356,3.151,7.983.061.156-.111.128c-1.5,1.735-2.964,3.561-4.411,5.429a130.422,130.422,0,0,0-7.98,11.5c-1.153,1.942-2.272,3.862-3.219,5.816-.986,1.934-1.773,3.907-2.583,5.83l-8.544,20.418-5.806,13.749c-.685,1.593-1.223,2.842-1.6,3.727l-.43.964A1.8,1.8,0,0,1,703.876,357.99Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M794.742,435.831a2.611,2.611,0,0,1-.313.33l-.958.932a28.212,28.212,0,0,1-4.094,3.105,27.654,27.654,0,0,1-7.495,3.141,30.313,30.313,0,0,1-10.734.683,34.193,34.193,0,0,1-6.145-1.3c-2.091-.666-4.185-1.484-6.4-2.263-4.4-1.6-9.122-3.259-14.091-5-9.939-3.481-20.9-7.207-32.448-10.995-23.1-7.588-44.162-13.983-59.427-18.541l-18.092-5.353-4.918-1.46-1.275-.394a2.773,2.773,0,0,1-.429-.152,2.823,2.823,0,0,1,.445.1l1.29.341,4.947,1.36c4.291,1.2,10.493,2.958,18.143,5.183,15.3,4.462,36.382,10.8,59.49,18.39,11.55,3.789,22.511,7.532,32.445,11.04,4.965,1.758,9.68,3.437,14.077,5.053,2.2.786,4.321,1.624,6.37,2.287a33.97,33.97,0,0,0,6.061,1.321,30.239,30.239,0,0,0,10.614-.594,27.977,27.977,0,0,0,7.459-3.024,30.625,30.625,0,0,0,4.13-3l.993-.888A2.82,2.82,0,0,1,794.742,435.831Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M627.7,398.717c-.018.117-1.415-.188-3.674-.1a16.9,16.9,0,0,0-3.9.643,17.994,17.994,0,0,0-4.385,2,20.423,20.423,0,0,0-6.1,6.266c-1.2,1.925-1.711,3.25-1.81,3.208a3.408,3.408,0,0,1,.3-.953,17.005,17.005,0,0,1,1.175-2.458,19.13,19.13,0,0,1,6.134-6.533,17.413,17.413,0,0,1,4.546-2.023,15.749,15.749,0,0,1,4.023-.543,13.289,13.289,0,0,1,2.717.243A3.5,3.5,0,0,1,627.7,398.717Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M602.9,390.907c-.017-.009.017-.1.1-.282a2.714,2.714,0,0,1,.494-.7,5.055,5.055,0,0,1,2.8-1.389,14.271,14.271,0,0,1,4.622.01,26.656,26.656,0,0,1,5.483,1.333,24.059,24.059,0,0,1,8.7,5.323,18.569,18.569,0,0,1,2.016,2.359,4.442,4.442,0,0,1,.584.977c-.089.066-.97-1.3-2.871-3.051a25.775,25.775,0,0,0-8.614-5.084,28.122,28.122,0,0,0-5.366-1.348,14.791,14.791,0,0,0-4.482-.131,5.136,5.136,0,0,0-2.714,1.156C603.126,390.56,602.949,390.935,602.9,390.907Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M632.285,322.247a9.683,9.683,0,0,1-.359-1.623c-.159-.507-.392-1.117-.634-1.83-.342-.674-.676-1.47-1.165-2.285a32.325,32.325,0,0,0-4.013-5.337,42.951,42.951,0,0,0-6.147-5.407,36.983,36.983,0,0,0-13.439-6.173,27.876,27.876,0,0,0-4.475-.569,9.715,9.715,0,0,1-1.664-.136,9.6,9.6,0,0,1,1.669-.081,23.448,23.448,0,0,1,4.547.4,35.345,35.345,0,0,1,13.688,6.107,41.238,41.238,0,0,1,6.2,5.513,30.611,30.611,0,0,1,3.977,5.49c.475.842.792,1.667,1.111,2.363.221.74.427,1.371.556,1.9A9.43,9.43,0,0,1,632.285,322.247Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M764.727,343.925c.153,0,.278,8.628.278,19.268s-.125,19.27-.278,19.27-.279-8.626-.279-19.27S764.573,343.925,764.727,343.925Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M592.128,300.012s-.067.243-.22.71-.418,1.15-.643,2.086c-.52,1.852-1.178,4.619-1.916,8.222-1.489,7.2-3.323,17.746-5.379,30.943-1.021,6.6-2.11,13.864-3.18,21.714-.545,3.92-.882,8.008-1.166,12.238s-.505,8.6-.668,13.094c-.325,8.99-.516,18.486-.256,28.379.075,2.472.166,4.971.373,7.482.063,1.263.269,2.5.424,3.758a30.121,30.121,0,0,0,.912,3.691,21.043,21.043,0,0,0,3.542,6.772,15.284,15.284,0,0,0,6.081,4.683l.034.013.011.006a92.621,92.621,0,0,0,15.853,6.055c5.527,1.655,11.237,2.991,17.037,4.184a234.612,234.612,0,0,0,38.28,4.661,177.856,177.856,0,0,0,18.274-.476c5.954-.411,11.758-1.034,17.373-1.867a183.208,183.208,0,0,0,31.181-7.248,159.874,159.874,0,0,0,25.212-10.818l.027.347L718.726,426.4l-9.313-3.326-2.408-.874c-.541-.2-.813-.314-.813-.314s.284.08.831.263l2.426.824,9.346,3.231,34.646,12.082.407.142-.38.2a159.253,159.253,0,0,1-25.25,10.914,182.871,182.871,0,0,1-31.25,7.321c-5.628.843-11.443,1.473-17.409,1.892a178.458,178.458,0,0,1-18.328.492,234.3,234.3,0,0,1-38.375-4.66c-5.814-1.2-11.538-2.536-17.083-4.2a92.905,92.905,0,0,1-15.955-6.1l.044.019a15.759,15.759,0,0,1-6.333-4.863,21.572,21.572,0,0,1-3.63-6.948,30.678,30.678,0,0,1-.926-3.765c-.158-1.275-.366-2.544-.427-3.807-.205-2.525-.294-5.03-.367-7.508-.249-9.913-.043-19.415.3-28.412q.257-6.748.7-13.106c.294-4.233.642-8.336,1.2-12.266,1.091-7.852,2.2-15.113,3.247-21.711,2.1-13.194,3.994-23.73,5.543-30.928.768-3.6,1.457-6.363,2.009-8.209.241-.933.534-1.611.692-2.076S592.128,300.012,592.128,300.012Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M627.582,391.329c13.16-14.572,12.582-40.484,5.029-58.87-.7,19.918-3.047,37.58-4.847,56.935",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M632.639,336.19a2.82,2.82,0,0,1-.005.638l-.118,1.819c-.13,1.653-.308,3.917-.525,6.682l-1.815,22.036c-.672,8.576-1.28,16.337-1.727,22.045-.209,2.765-.379,5.03-.5,6.682l-.157,1.816a2.742,2.742,0,0,1-.093.631,2.773,2.773,0,0,1-.019-.637c.014-.478.031-1.081.053-1.823.053-1.582.169-3.869.327-6.7.323-5.652.863-13.454,1.565-22.064s1.417-16.394,1.978-22.026c.29-2.759.528-5.019.7-6.667.091-.737.164-1.336.223-1.809A2.724,2.724,0,0,1,632.639,336.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M665.085,309.862c.154,0,.278,5.059.278,11.3s-.124,11.3-.278,11.3-.279-5.058-.279-11.3S664.931,309.862,665.085,309.862Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M656.511,347.4a11.571,11.571,0,0,0,2.422,5.993c1.236,1.607,3.751,3.18,5.775,3.065a8.8,8.8,0,0,0,7.771-3.9c2.463-3.922,3.071-12.079,1.095-16.9-1.358-3.317-4.41-6.4-7.993-6.485-4.7-.111-7.653,3.288-8.658,6.728",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M656.923,335.9a7.172,7.172,0,0,1,.871-2.306,9.474,9.474,0,0,1,1.765-2.314,8.207,8.207,0,0,1,3.329-1.955,8.383,8.383,0,0,1,2.237-.358,6.792,6.792,0,0,1,2.448.322,9.638,9.638,0,0,1,4.367,3.132,12.6,12.6,0,0,1,2.568,5.347,23.057,23.057,0,0,1,.477,6.336c-.217,3.349-.874,6.681-2.728,9.228a8.268,8.268,0,0,1-3.55,2.677,9.65,9.65,0,0,1-4.018.676h.032a6.044,6.044,0,0,1-2.88-.714,9.491,9.491,0,0,1-2.166-1.51,10.78,10.78,0,0,1-2.359-3.515,10.347,10.347,0,0,1-.747-2.6,6.565,6.565,0,0,1-.067-.705c-.006-.16,0-.243.009-.244a14.462,14.462,0,0,0,1.043,3.439,10.828,10.828,0,0,0,2.37,3.35,9.221,9.221,0,0,0,2.1,1.41,5.665,5.665,0,0,0,2.671.631h.033a8.553,8.553,0,0,0,7.107-3.22c1.726-2.385,2.389-5.661,2.594-8.937.23-4.23-.479-8.492-2.886-11.329a9.233,9.233,0,0,0-4.114-3.017,6.388,6.388,0,0,0-2.293-.331,8.025,8.025,0,0,0-5.366,2.111,9.716,9.716,0,0,0-1.788,2.194A19.886,19.886,0,0,0,656.923,335.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M654.007,347.614a11.574,11.574,0,0,0,2.422,5.993c1.237,1.607,3.752,3.18,5.776,3.064a8.8,8.8,0,0,0,7.771-3.9c2.463-3.922,3.07-12.078,1.095-16.9-1.358-3.317-4.41-6.4-7.993-6.485-4.7-.112-7.653,3.288-8.658,6.728",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M654.42,336.114a7.181,7.181,0,0,1,.87-2.306,9.5,9.5,0,0,1,1.765-2.314,8.2,8.2,0,0,1,3.33-1.955,8.382,8.382,0,0,1,2.237-.358,6.762,6.762,0,0,1,2.447.322,9.633,9.633,0,0,1,4.368,3.132A12.592,12.592,0,0,1,672,337.982a23.021,23.021,0,0,1,.478,6.336c-.217,3.349-.875,6.681-2.728,9.228a8.265,8.265,0,0,1-3.55,2.676,9.637,9.637,0,0,1-4.018.676h.032a6.041,6.041,0,0,1-2.88-.714,9.441,9.441,0,0,1-2.166-1.511,10.769,10.769,0,0,1-2.359-3.515,10.286,10.286,0,0,1-.747-2.6,6.624,6.624,0,0,1-.068-.7.7.7,0,0,1,.009-.244,14.518,14.518,0,0,0,1.043,3.439,10.872,10.872,0,0,0,2.37,3.35,9.251,9.251,0,0,0,2.1,1.41,5.675,5.675,0,0,0,2.671.631h.032a8.556,8.556,0,0,0,7.108-3.219c1.725-2.385,2.389-5.662,2.594-8.937.23-4.231-.48-8.493-2.887-11.329a9.224,9.224,0,0,0-4.113-3.017,6.345,6.345,0,0,0-2.293-.331,8.01,8.01,0,0,0-5.366,2.111,9.747,9.747,0,0,0-1.789,2.193A19.91,19.91,0,0,0,654.42,336.114Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M658.546,334.911a5.505,5.505,0,0,0-5.742,3.308,9.492,9.492,0,0,0,.013,6.978,8.65,8.65,0,0,0,1.78,3.144,4.7,4.7,0,0,0,3.19,1.551,5.554,5.554,0,0,0,4.415-2.609,9.957,9.957,0,0,0,1.508-8.2c-.488-1.854-1.853-3.755-3.769-3.8",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M659.941,335.276a1.013,1.013,0,0,1,.425-.012,2.981,2.981,0,0,1,1.16.393,5.688,5.688,0,0,1,2.446,3.681,10.107,10.107,0,0,1-.66,6.545,8.527,8.527,0,0,1-2.4,3.146,4.631,4.631,0,0,1-4.126.988,5.746,5.746,0,0,1-3.3-2.694,12.047,12.047,0,0,1-1.373-3.694,8.22,8.22,0,0,1,1.068-6.459,5.74,5.74,0,0,1,3.73-2.372,4.078,4.078,0,0,1,1.22,0c.274.058.413.1.409.116a7.938,7.938,0,0,0-1.591.1,5.683,5.683,0,0,0-3.447,2.386,7.926,7.926,0,0,0-.887,6.129,11.757,11.757,0,0,0,1.338,3.514,5.242,5.242,0,0,0,2.978,2.441,4.1,4.1,0,0,0,3.643-.882,8.1,8.1,0,0,0,2.267-2.934,9.876,9.876,0,0,0,.741-6.24,5.622,5.622,0,0,0-2.176-3.583A4.5,4.5,0,0,0,659.941,335.276Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M663.939,352.488c-.085.021-.2-.336-.569-.766a3.984,3.984,0,0,0-1.825-1.17,10.061,10.061,0,0,0-2.245-.349c-.6-.043-.974-.092-.977-.17s.365-.166.974-.223a6.321,6.321,0,0,1,2.415.211,3.546,3.546,0,0,1,1.979,1.473C664.025,352.059,664,352.481,663.939,352.488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M664.779,333.454c.049.048-.165.382-.663.776a5.32,5.32,0,0,1-4.71.851c-.6-.2-.921-.434-.892-.495a8.034,8.034,0,0,0,6.265-1.132Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M738.252,256.863c.008-.017.129.028.352.129a10.339,10.339,0,0,1,.951.491,19.425,19.425,0,0,1,3.2,2.291,23,23,0,0,1,6.884,10.89,69.717,69.717,0,0,1,2.62,12.678c.185,1.646.286,2.982.348,3.906a7.047,7.047,0,0,1,.027,1.44,7.238,7.238,0,0,1-.243-1.419l-.522-3.877a81.888,81.888,0,0,0-2.764-12.57,23.686,23.686,0,0,0-6.613-10.755A36.477,36.477,0,0,0,738.252,256.863Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M724.934,374.564c3.1-.119,5.575-3.209,8.672-3.043a4.309,4.309,0,1,1-.727,8.583c-3.253-.378-5.157-4.191-8.349-4.924",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M751.214,377.2a18.477,18.477,0,0,1-2.9-.241l.169-1.056c3.831.615,7.046-.016,9.563-1.866,3.165-2.326,5.2-6.487,6.062-12.367l.034-.224c.35-2.33.833-48.065.834-56.747,0-13.562-11.9-15.414-12.411-15.486-.482-.089-11.3-1.9-17.045,12.917-6.012,15.513-15.622,45.407-16.258,48.911-.079.429-.2.961-.334,1.577-1,4.486-3.078,13.82,3.148,19.2,6.94,5.993,12.413,3.674,12.642,3.574l.439.975c-.256.113-6.3,2.724-13.781-3.74-6.709-5.794-4.536-15.55-3.492-20.238.134-.6.25-1.117.325-1.535.641-3.532,10.287-33.553,16.315-49.106,6.073-15.675,18.094-13.611,18.214-13.586s13.309,2.036,13.307,16.541c0,7.153-.475,54.431-.846,56.9l-.033.221c-.9,6.173-3.083,10.572-6.488,13.073A12.284,12.284,0,0,1,751.214,377.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M765.509,313.451a19.929,19.929,0,0,0-2.226-5.33,18.135,18.135,0,0,0-11.094-7.821,20.1,20.1,0,0,0-13.536,1.765,23.86,23.86,0,0,0-4.706,3.371c-.014-.013.07-.125.244-.328a9.14,9.14,0,0,1,.8-.853,16.153,16.153,0,0,1,3.476-2.537,19.883,19.883,0,0,1,13.849-1.961,18.279,18.279,0,0,1,7.054,3.382,17.729,17.729,0,0,1,4.248,4.775,14.193,14.193,0,0,1,1.649,3.979,8.349,8.349,0,0,1,.216,1.15A1.152,1.152,0,0,1,765.509,313.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M792.738,398.934a36.654,36.654,0,0,0-1.466-4.562,19.935,19.935,0,0,0-7.254-8.7,15.666,15.666,0,0,0-5.886-2.123c-1.926-.321-3.694-.436-5.178-.538l-3.522-.243a5.779,5.779,0,0,1-1.287-.176,5.847,5.847,0,0,1,1.3-.041l3.531.067a44.006,44.006,0,0,1,5.242.425,15.662,15.662,0,0,1,6.1,2.16,19.385,19.385,0,0,1,7.317,9.021,17.161,17.161,0,0,1,.976,3.417A4.854,4.854,0,0,1,792.738,398.934Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M738.8,381.086s10.514-15.926,13.2-18.013,25.637-12.448,28.325-10.782,1.034,5.281,1.034,5.281,9.717-3.4,10.751-2.062a4.805,4.805,0,0,1,0,5.476s5.375-.827,5.375.827a6.807,6.807,0,0,1-3.1,5.583c-2.481,1.86-18.613,12.6-19.908,15.566l-5.225-.317Z",
    fill: "#e4ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M769.062,376.532a3.789,3.789,0,0,1,.48-1,18.568,18.568,0,0,1,1.728-2.49,28.944,28.944,0,0,1,7.626-6.42,57.558,57.558,0,0,1,9.02-4.239c1.191-.452,2.161-.8,2.837-1.022a4.214,4.214,0,0,1,1.069-.3,4.331,4.331,0,0,1-.991.5l-2.768,1.185a72.931,72.931,0,0,0-8.881,4.351,31.948,31.948,0,0,0-7.612,6.2C769.905,375.192,769.149,376.585,769.062,376.532Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M755.724,376.273a5.6,5.6,0,0,1,.509-1.17c.362-.736.9-1.8,1.618-3.077a29.273,29.273,0,0,1,2.9-4.292,13.514,13.514,0,0,1,2.2-2.182c.887-.6,1.821-1.16,2.786-1.733A76.835,76.835,0,0,1,776,358.7a30.092,30.092,0,0,1,3.3-1.106,5.654,5.654,0,0,1,1.26-.225c.023.094-1.743.5-4.413,1.695A97.685,97.685,0,0,0,766.02,364.3c-.957.568-1.9,1.128-2.76,1.7a13.631,13.631,0,0,0-2.119,2.064,32.3,32.3,0,0,0-2.951,4.16l-1.766,2.98A5.681,5.681,0,0,1,755.724,376.273Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M739.67,212.319c-2.795,10.082-7.738,17.8-9.881,17.211,0,0,1.51-6.42,3.523-16.686,2.336-11.91,2.667-20.308,7.54-19.856C743.067,193.194,742.466,202.237,739.67,212.319Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M654.171,212.319c2.8,10.082,7.439,17.869,9.582,17.275,0,0-2.28-8.317-3.635-17.056-1.859-11.994-2.256-20-7.129-19.55C650.774,193.194,651.375,202.237,654.171,212.319Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M739.67,212.319c-2.795,10.082-7.738,17.8-9.881,17.211,0,0,1.51-6.42,3.523-16.686,2.336-11.91,2.667-20.308,7.54-19.856C743.067,193.194,742.466,202.237,739.67,212.319Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.257
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M654.171,212.319c2.8,10.082,7.439,17.869,9.582,17.275,0,0-2.28-8.317-3.635-17.056-1.859-11.994-2.256-20-7.129-19.55C650.774,193.194,651.375,202.237,654.171,212.319Z",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.257
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M729.789,229.53c-8.86,29.116-33.051,29.6-33.051,29.6s-25.552-.068-33.187-30.3c-5.038-19.946-17.16-50.491-2.627-73.128,8.225-12.811,68.026-17.931,75.07,0S734.984,212.456,729.789,229.53Z",
    fill: "#f7eae8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M704.815,235.08c.644-.216-1.343-3-8.548-3.034-6.114-.026-9.178,2.5-8.625,2.878.685.466,3.121.151,8.378.151S704.113,235.316,704.815,235.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M696.27,231.9c6.271.026,8.349,2.011,8.7,2.409.186.209.565.714.072.88h0a15.918,15.918,0,0,1-3.775.1c-1.382-.032-3.1-.072-5.249-.072-1.8,0-3.265.037-4.445.067-2.375.06-3.681.093-4.241-.289-.334-.228.136-.719.688-1.1a15.027,15.027,0,0,1,8.156-1.99Zm-4.74,3.1c1.19-.03,2.67-.068,4.49-.068,2.168,0,3.9.04,5.29.072a22.894,22.894,0,0,0,3.247-.025c.092-.118-.142-.642-1.055-1.219s-3.073-1.552-7.239-1.57h-.087a13.987,13.987,0,0,0-7.31,1.7c-.84.525-.993.9-.916.964a3.78,3.78,0,0,0,1.608.184C690.094,235.035,690.753,235.018,691.53,235Z",
    fill: "#253137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M696.776,219.566a5.356,5.356,0,0,1-2.115-6.411c1-2.951,1.134-8.6,1.135-8.659l1.085.024c-.005.238-.142,5.874-1.192,8.983a4.272,4.272,0,0,0,1.721,5.181Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M658.192,209.3s-5.115-20.262-6.026-30.494-1.987-23.973,9.542-28.652,7.984,9.607,7.984,9.607-9.118,6.131-10.941,21.485C657.76,189.585,658.192,209.3,658.192,209.3Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M734.826,208.992s5.674-19.956,6.586-30.188,1.987-23.973-9.543-28.652-7.983,9.607-7.983,9.607,9.117,6.131,10.941,21.485C735.818,189.585,734.826,208.992,734.826,208.992Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M725.411,164.672s-14.045,2.239-23.457-2.184c-2.756-1.3-16.135,4.4-22.283,3.248-11.771-2.2-16.94-11.78-17.172-12.765-.678-2.883-3.495-6.99,5.015-13.372,11.771-8.829,26.289-6.687,28.72-9.27s4.875-4.163,9.574-3.693c12.612,1.262,13.23,8.662,20.324,9.771,9.232,1.444,12.347,5.167,12.947,12.917C740.219,164.071,725.411,164.672,725.411,164.672Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M698.666,128.353s-3.951,2.837-13.879,14.386-15.095,10.84-16.21,11.042c0,0,8.568,1.479,17.628-10.434S698.666,128.353,698.666,128.353Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M714.242,164.292s16.563,1.957,23.781-6.7c0,0-1.519,9.05-23.4,6.847Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M687,164.534c-19.518,2.729-25.129-13.381-25.035-13.083,3.075,9.774,10.845,13.539,16.53,15a25.7,25.7,0,0,0,5.082.867c.919.072,1.486.07,1.486.07l.035-.009c18.665.162,33.776-19.576,33.776-19.576C706.209,158.706,694.972,162.963,687,164.534Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M684.988,209.552l6.449-6.449v6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M676.691,209.552l-3.38-3.38v-8.3l6.449-6.449h8.3l3.38,3.38v8.3l-6.449,6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M679.76,191.426l-6.449,6.449v-6.449Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M714.43,210.124l6.449-6.449v6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M706.133,210.124l-3.38-3.38v-8.3L709.2,192h8.3l3.38,3.38v8.3l-6.449,6.449Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M709.2,192l-6.449,6.449V192Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M720.309,188.953A10.988,10.988,0,0,0,712.3,187a1.778,1.778,0,0,1-1.961-2.182h0a1.772,1.772,0,0,1,1.169-1.3,10.472,10.472,0,0,1,11.149,2.616,1.755,1.755,0,0,1,.415,1.623l-.027.116A1.78,1.78,0,0,1,720.309,188.953Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.836,
    cy: 0.811,
    rx: 0.836,
    ry: 0.811,
    transform: "translate(710.99 200.784)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M682.374,200.619a.811.811,0,1,0,.835.811A.824.824,0,0,0,682.374,200.619Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M720.183,198.257a8.778,8.778,0,0,0-17.046,1.353l-.009.005a8.287,8.287,0,0,0-12.09-.476,8.789,8.789,0,0,0-17.021-1.1c-14.665-5.2-18.278-5.877-19.247-5.7-.29.054-.537.489-.585.729l.756.306a1.35,1.35,0,0,1,.15-.19c1.274-.147,10.392,2.819,18.649,5.74a8.8,8.8,0,0,0,16.252,6.194,2.484,2.484,0,0,0,.748-.252,2.357,2.357,0,0,0,.683-.51,2.789,2.789,0,0,0,.689-1.5,4.245,4.245,0,0,0-.516-2.955,7.35,7.35,0,0,1,10.9.389,4.424,4.424,0,0,0-.409,2.782,2.787,2.787,0,0,0,.69,1.495,2.34,2.34,0,0,0,.683.51,2.519,2.519,0,0,0,.749.253,8.8,8.8,0,0,0,16.251-6.195c8.383-2.968,17.489-6,18.527-5.745-.034-.009.938-.385.938-.385C739.633,192.4,739.237,191.507,720.183,198.257Zm-37.81,10.384a7.894,7.894,0,1,1,7.894-7.893A7.9,7.9,0,0,1,682.373,208.641Zm8.8-5.332a1.621,1.621,0,0,1-.378.52,1.422,1.422,0,0,1-.219.133,8.767,8.767,0,0,0,.6-2.946,1.861,1.861,0,0,1,.188.517A3.734,3.734,0,0,1,691.171,203.309Zm12.236.737a1.632,1.632,0,0,1-.378-.52,3.739,3.739,0,0,1-.19-1.777,1.837,1.837,0,0,1,.188-.518,8.757,8.757,0,0,0,.6,2.948A1.561,1.561,0,0,1,703.407,204.046Zm8.419,4.81a7.893,7.893,0,1,1,7.893-7.893A7.9,7.9,0,0,1,711.826,208.856Z",
    fill: "#302420"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M673.891,188.737a10.988,10.988,0,0,1,8.013-1.953,1.778,1.778,0,0,0,1.96-2.182h0a1.769,1.769,0,0,0-1.168-1.3,10.472,10.472,0,0,0-11.149,2.616,1.761,1.761,0,0,0-.416,1.623l.028.115A1.78,1.78,0,0,0,673.891,188.737Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M747.172,263.055l37.334,20.29s30.386,17.728,23.852,100.3",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.018
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M513.284,469.508l33.431,1.46-1.546,35.43-33.432-1.46-2.569,58.869-43.97-1.92,2.57-58.868L354.21,498.062l.086-26.98,121-173.8,45.422,1.982Zm-115.011-5.02,71.041,3.1L474,360.21l-1.075-.412-3.974,7.655Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M513.284,469.508l33.431,1.46-1.546,35.43-33.432-1.46-2.569,58.869-43.97-1.92,2.57-58.868L354.21,498.062l.086-26.98,121-173.8,45.422,1.982Zm-115.011-5.02,71.041,3.1L474,360.21l-1.075-.412-3.974,7.655Z",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M541.242,470.729l33.432,1.46-1.546,35.43-33.433-1.46-2.569,58.868-43.969-1.919,2.57-58.868-113.558-4.957.086-26.981,121-173.8,45.421,1.983Zm-115.011-5.02,71.042,3.1,4.688-107.38-1.075-.411-3.974,7.654Z",
    fill: "#c06c84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M947.543,469.923l33.3-3.256,3.452,35.3-33.3,3.256,5.735,58.645-43.8,4.284L907.193,509.5,794.067,520.566l-3.71-26.725,95.35-189.09,45.25-4.426ZM832.969,481.129l70.772-6.921L893.279,367.235l-1.122-.255-2.858,8.137Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M947.543,469.923l33.3-3.256,3.452,35.3-33.3,3.256,5.735,58.645-43.8,4.284L907.193,509.5,794.067,520.566l-3.71-26.725,95.35-189.09,45.25-4.426ZM832.969,481.129l70.772-6.921L893.279,367.235l-1.122-.255-2.858,8.137Z",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M975.4,467.2l33.3-3.258,3.452,35.3-33.3,3.258,5.736,58.644-43.8,4.283-5.735-58.644L821.919,517.842l-3.709-26.724,95.349-189.092,45.25-4.425ZM860.822,478.4l70.771-6.922L921.132,364.511l-1.123-.255-2.857,8.137Z",
    fill: "#c06c84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M738.28,487.114q.357,37.188-16.216,56.857t-45.378,19.947q-28.939.277-46.016-19.07t-17.435-56.533l-.419-43.6q-.355-37.053,16.216-56.856t45.508-20.08q28.8-.276,45.886,19.2t17.435,56.533ZM706,438.932q-.225-23.415-8.189-34.592t-23.022-11.03q-15.059.144-22.74,11.47t-7.458,34.742l.509,52.98q.227,23.55,8.257,34.788t23.088,11.1q15.056-.144,22.674-11.469t7.39-35Z",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M756.61,486.938q.357,37.188-16.215,56.857t-45.379,19.947q-28.938.277-46.015-19.07t-17.435-56.533l-.419-43.6q-.355-37.053,16.215-56.856t45.509-20.08q28.8-.276,45.885,19.2t17.436,56.533Zm-32.283-48.182q-.225-23.415-8.189-34.592t-23.022-11.03q-15.059.144-22.74,11.47t-7.458,34.742l.509,52.98q.225,23.55,8.256,34.788t23.088,11.095q15.055-.144,22.675-11.469t7.39-35Z",
    fill: "#c06c84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M631.278,447.128c.036.1-4.221,1.787-9.507,3.773s-9.6,3.52-9.64,3.423,4.219-1.786,9.508-3.774S631.242,447.032,631.278,447.128Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M632.336,464.358c.036.1-4.221,1.786-9.507,3.773s-9.6,3.519-9.641,3.422,4.22-1.786,9.509-3.773S632.3,464.261,632.336,464.358Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M633.394,481.587c.036.1-4.221,1.787-9.508,3.773s-9.6,3.519-9.64,3.423,4.22-1.786,9.509-3.774S633.357,481.49,633.394,481.587Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M634.452,498.817c.036.1-4.221,1.786-9.508,3.773s-9.6,3.519-9.64,3.422,4.22-1.786,9.508-3.773S634.415,498.72,634.452,498.817Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M635.509,516.046a2.729,2.729,0,0,1-.659.326c-.433.187-1.064.445-1.846.758-1.566.624-3.737,1.462-6.143,2.366s-4.593,1.7-6.182,2.265c-.794.28-1.439.5-1.888.646a2.827,2.827,0,0,1-.711.189,2.8,2.8,0,0,1,.66-.326c.433-.187,1.064-.445,1.846-.757,1.565-.625,3.737-1.463,6.143-2.368s4.592-1.7,6.181-2.264c.8-.28,1.44-.5,1.889-.646A2.835,2.835,0,0,1,635.509,516.046Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M640.431,531.807a14.932,14.932,0,0,1-2.18.961c-1.363.549-3.256,1.282-5.354,2.071s-4.007,1.483-5.394,1.968a14.894,14.894,0,0,1-2.273.712,15.009,15.009,0,0,1,2.18-.96c1.363-.549,3.256-1.282,5.355-2.071s4.006-1.483,5.393-1.968A15.123,15.123,0,0,1,640.431,531.807Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M650.96,546.268a11.965,11.965,0,0,1-1.936.869c-1.213.492-2.9,1.148-4.768,1.85s-3.569,1.319-4.807,1.748a12.036,12.036,0,0,1-2.029.621,11.854,11.854,0,0,1,1.936-.869c1.213-.493,2.9-1.148,4.768-1.851s3.569-1.319,4.807-1.747A11.806,11.806,0,0,1,650.96,546.268Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M668.464,555.747a11.962,11.962,0,0,1-1.936.869c-1.214.492-2.9,1.148-4.768,1.85s-3.57,1.319-4.807,1.748a12.036,12.036,0,0,1-2.029.621,11.852,11.852,0,0,1,1.936-.869c1.213-.493,2.9-1.148,4.768-1.851s3.569-1.319,4.806-1.747A11.8,11.8,0,0,1,668.464,555.747Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M721.258,518.982c.042.094-5.423,2.643-12.206,5.692s-12.318,5.446-12.36,5.352,5.421-2.643,12.207-5.694S721.215,518.887,721.258,518.982Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M724.842,504.218c.043.1-4.469,2.215-10.076,4.736s-10.188,4.488-10.231,4.393,4.469-2.214,10.078-4.735S724.8,504.124,724.842,504.218Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M726.492,487.635c.043.1-4.469,2.215-10.076,4.735s-10.188,4.489-10.231,4.394,4.469-2.214,10.077-4.736S726.45,487.541,726.492,487.635Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M728.142,471.052c.043.094-4.469,2.215-10.076,4.735s-10.188,4.489-10.231,4.394,4.469-2.214,10.077-4.736S728.1,470.958,728.142,471.052Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M729.792,454.469c.043.094-4.469,2.215-10.076,4.735s-10.189,4.489-10.231,4.394,4.468-2.214,10.077-4.736S729.75,454.374,729.792,454.469Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M726.492,439.7c.043.094-4.469,2.215-10.076,4.735s-10.188,4.488-10.231,4.394,4.469-2.214,10.077-4.736S726.45,439.606,726.492,439.7Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M726.492,423.8c.043.094-4.469,2.215-10.076,4.735s-10.188,4.489-10.231,4.394,4.469-2.214,10.077-4.736S726.45,423.709,726.492,423.8Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M724.842,408.832c.043.094-4.469,2.215-10.076,4.735s-10.188,4.489-10.231,4.394,4.469-2.214,10.078-4.736S724.8,408.737,724.842,408.832Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M710.62,398.4a122.041,122.041,0,0,1-12.352,5.553A122.639,122.639,0,0,1,710.62,398.4Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M703.015,392.015a122.186,122.186,0,0,1-12.351,5.552,122.446,122.446,0,0,1,12.351-5.552Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M632.094,426.244c.037.1-4.22,1.786-9.507,3.773s-9.6,3.519-9.64,3.422,4.22-1.786,9.508-3.773S632.058,426.147,632.094,426.244Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M637.394,404.756c.036.1-4.58,1.921-10.309,4.074s-10.406,3.821-10.442,3.724,4.579-1.921,10.31-4.075S637.358,404.659,637.394,404.756Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M651.234,383.491c.036.1-5.817,2.386-13.072,5.112s-13.169,4.859-13.206,4.762,5.816-2.386,13.074-5.113S651.2,383.394,651.234,383.491Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M753.507,519.22a1.977,1.977,0,0,1-.3-.1l-.867-.336c-.383-.142-.881-.245-1.453-.409a14.1,14.1,0,0,0-2.041-.246c-3.074-.2-7.681.921-12.137,4.259a34.551,34.551,0,0,0-6.43,6.356c-2.067,2.53-4.087,5.387-6.385,8.271a37.835,37.835,0,0,1-8.3,8.042,30.032,30.032,0,0,1-11.478,4.651,29.525,29.525,0,0,1-12.376-.413,58.427,58.427,0,0,1-10.843-4.024c-3.343-1.549-6.463-3.129-9.462-4.428a49.747,49.747,0,0,0-8.582-2.922,31.751,31.751,0,0,0-7.416-.854,22.506,22.506,0,0,0-5.58.759,19.989,19.989,0,0,0-3.321,1.3l-.824.435a.159.159,0,1,1-.019-.033l.808-.469a18.517,18.517,0,0,1,3.315-1.375,22.224,22.224,0,0,1,5.617-.829,31.556,31.556,0,0,1,7.479.806,49.508,49.508,0,0,1,8.647,2.894c3.015,1.292,6.144,2.863,9.483,4.4a58.5,58.5,0,0,0,10.784,3.979,29.213,29.213,0,0,0,12.224.4,29.769,29.769,0,0,0,11.339-4.587,37.623,37.623,0,0,0,8.234-7.953c2.3-2.867,4.327-5.72,6.413-8.252a34.641,34.641,0,0,1,6.515-6.374c4.517-3.342,9.194-4.436,12.3-4.189a13.619,13.619,0,0,1,2.057.282c.575.176,1.073.293,1.454.447l.858.372A2.183,2.183,0,0,1,753.507,519.22Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M758.046,471.161c.007.04-.512.108-1.4.4a13.844,13.844,0,0,0-3.476,1.86c-1.374.959-2.862,2.3-4.616,3.683a33.524,33.524,0,0,1-6.187,3.806,34.039,34.039,0,0,1-12.718,3.287c-.842.069-1.609.044-2.278.06-.671-.027-1.248-.039-1.718-.075l-1.081-.11a1.411,1.411,0,0,1-.374-.064,1.471,1.471,0,0,1,.38-.011l1.082.039,1.71.011c.666-.035,1.426-.029,2.261-.115a35.43,35.43,0,0,0,12.575-3.36,34.6,34.6,0,0,0,6.137-3.741c1.75-1.358,3.267-2.685,4.676-3.628a12.96,12.96,0,0,1,3.583-1.782,7.785,7.785,0,0,1,1.066-.23A1.494,1.494,0,0,1,758.046,471.161Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M664,487.844a1.644,1.644,0,0,1-.4-.056c-.255-.056-.64-.113-1.118-.249a17.031,17.031,0,0,1-3.858-1.692,38.725,38.725,0,0,1-5.04-3.682c-1.809-1.494-3.738-3.2-5.951-4.732A20.512,20.512,0,0,0,640.8,474.3a21.015,21.015,0,0,0-10.249.046c-.958.242-1.475.429-1.487.393a1.614,1.614,0,0,1,.365-.162c.244-.092.6-.238,1.082-.372a18.635,18.635,0,0,1,4.144-.753,20.312,20.312,0,0,1,13.19,3.67c2.24,1.548,4.169,3.273,5.96,4.777a41.283,41.283,0,0,0,4.956,3.72,18.741,18.741,0,0,0,3.763,1.78C663.47,487.681,664,487.812,664,487.844Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M664.124,419.787a8.457,8.457,0,0,1-1.2.439c-.39.135-.87.287-1.438.426s-1.207.334-1.933.464c-.721.151-1.513.309-2.374.416-.856.143-1.78.21-2.751.3a38.817,38.817,0,0,1-12.581-1.183c-.938-.267-1.834-.505-2.648-.8-.826-.266-1.575-.569-2.255-.851-.689-.263-1.283-.569-1.813-.816s-.975-.482-1.332-.687a8.456,8.456,0,0,1-1.1-.655,8.287,8.287,0,0,1,1.164.525c.366.185.817.4,1.355.627s1.132.515,1.823.76c.682.265,1.43.551,2.254.8.812.285,1.7.51,2.636.766a40.814,40.814,0,0,0,12.473,1.173c.963-.078,1.881-.132,2.732-.261.855-.093,1.644-.235,2.364-.368.724-.112,1.364-.283,1.933-.407s1.053-.25,1.447-.363A8.217,8.217,0,0,1,664.124,419.787Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M753.961,419.6a1.149,1.149,0,0,1-.306-.147l-.836-.483a13.272,13.272,0,0,0-1.336-.73c-.535-.259-1.123-.594-1.823-.858l-1.082-.45c-.377-.153-.786-.268-1.2-.413-.824-.3-1.739-.513-2.693-.76a29.7,29.7,0,0,0-12.729-.112c-.959.23-1.878.422-2.707.712-.416.137-.827.245-1.207.392l-1.09.43c-.7.252-1.3.577-1.837.826a13.164,13.164,0,0,0-1.349.707l-.844.467a1.144,1.144,0,0,1-.309.142,1.165,1.165,0,0,1,.268-.2l.811-.53a11.367,11.367,0,0,1,1.327-.767,18.8,18.8,0,0,1,1.83-.884l1.092-.457c.381-.156.8-.272,1.214-.417a27.358,27.358,0,0,1,2.729-.754,28.9,28.9,0,0,1,12.879.113,27.605,27.605,0,0,1,2.715.8c.416.152.827.276,1.206.438l1.083.476a18.8,18.8,0,0,1,1.814.916,11.29,11.29,0,0,1,1.314.791l.8.544C753.877,419.521,753.968,419.593,753.961,419.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M709.941,370.7a3.63,3.63,0,0,1-.521.312l-1.527.827c-1.332.71-3.264,1.726-5.678,2.934a98.4,98.4,0,0,1-19.624,7.675,53.733,53.733,0,0,1-11.51,1.6,41.212,41.212,0,0,1-9.455-.811,32.992,32.992,0,0,1-6.117-1.87c-.706-.271-1.221-.56-1.583-.723a3.664,3.664,0,0,1-.536-.284,3.765,3.765,0,0,1,.568.215c.372.141.894.408,1.6.657a35.748,35.748,0,0,0,6.115,1.745,42.264,42.264,0,0,0,9.393.726,54.716,54.716,0,0,0,11.429-1.617,103.827,103.827,0,0,0,19.6-7.549l5.728-2.826,1.56-.765A3.749,3.749,0,0,1,709.941,370.7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M819.491,496.117a5.674,5.674,0,0,1-.986.753c-.653.456-1.61,1.1-2.8,1.878-2.383,1.56-5.71,3.661-9.434,5.9s-7.144,4.189-9.64,5.56c-1.248.685-2.264,1.229-2.974,1.591a5.611,5.611,0,0,1-1.127.517,5.654,5.654,0,0,1,1.028-.694l2.89-1.734L806,504.2l9.505-5.764L818.4,496.7A5.751,5.751,0,0,1,819.491,496.117Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M831.39,464.181a10.73,10.73,0,0,1-1.379,1c-.908.614-2.234,1.483-3.885,2.537-3.3,2.112-7.9,4.958-13.024,8.038s-9.8,5.8-13.214,7.726c-1.706.963-3.1,1.725-4.064,2.239a10.729,10.729,0,0,1-1.531.748,10.519,10.519,0,0,1,1.431-.924l3.979-2.381,13.13-7.855,13.1-7.9,3.971-2.4A10.663,10.663,0,0,1,831.39,464.181Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M847.3,434.95a11.447,11.447,0,0,1-1.448,1.011c-.952.621-2.342,1.5-4.071,2.566-3.458,2.134-8.276,5.012-13.635,8.125s-10.253,5.868-13.821,7.811c-1.783.973-3.235,1.744-4.246,2.263a11.357,11.357,0,0,1-1.6.756,11.605,11.605,0,0,1,1.5-.933l4.164-2.407,13.739-7.94,13.707-7.991,4.155-2.422A11.435,11.435,0,0,1,847.3,434.95Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M930.443,454.288a5.6,5.6,0,0,1-.993.735c-.658.444-1.62,1.069-2.818,1.828-2.4,1.518-5.737,3.563-9.479,5.735s-7.177,4.061-9.683,5.388c-1.253.663-2.273,1.189-2.985,1.54a5.564,5.564,0,0,1-1.13.5,5.637,5.637,0,0,1,1.033-.677l2.9-1.684,9.6-5.515,9.548-5.6,2.9-1.687A5.725,5.725,0,0,1,930.443,454.288Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M934.969,509.135a5.359,5.359,0,0,1-.958.729c-.634.44-1.564,1.06-2.721,1.813-2.315,1.506-5.546,3.535-9.167,5.69s-6.946,4.029-9.374,5.345c-1.213.658-2.2,1.18-2.891,1.528a5.356,5.356,0,0,1-1.1.494,5.351,5.351,0,0,1,1-.672l2.809-1.671,9.289-5.471,9.237-5.555,2.809-1.673A5.368,5.368,0,0,1,934.969,509.135Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M937.219,528.264a5.33,5.33,0,0,1-.958.728c-.634.441-1.564,1.061-2.721,1.814-2.315,1.506-5.546,3.535-9.167,5.69s-6.947,4.028-9.374,5.345c-1.213.658-2.2,1.18-2.892,1.527a5.344,5.344,0,0,1-1.1.495,5.351,5.351,0,0,1,1-.672l2.809-1.671,9.289-5.472,9.237-5.554,2.809-1.673A5.374,5.374,0,0,1,937.219,528.264Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M939.469,547.393a5.328,5.328,0,0,1-.958.728c-.634.441-1.564,1.061-2.721,1.814-2.315,1.506-5.547,3.534-9.167,5.69s-6.947,4.028-9.374,5.345c-1.214.658-2.2,1.18-2.892,1.527a5.344,5.344,0,0,1-1.1.495,5.351,5.351,0,0,1,1-.672l2.809-1.671,9.289-5.472,9.237-5.554,2.809-1.673A5.366,5.366,0,0,1,939.469,547.393Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M928.1,434.075a5.525,5.525,0,0,1-.993.734c-.657.445-1.62,1.07-2.817,1.829-2.4,1.518-5.738,3.563-9.48,5.735s-7.177,4.061-9.683,5.388c-1.253.663-2.273,1.189-2.985,1.539a5.693,5.693,0,0,1-1.13.5,5.638,5.638,0,0,1,1.033-.677l2.9-1.684,9.6-5.515,9.549-5.6,2.9-1.686A5.65,5.65,0,0,1,928.1,434.075Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M925.751,413.862a5.582,5.582,0,0,1-.993.734c-.657.445-1.62,1.069-2.817,1.828-2.395,1.518-5.738,3.563-9.48,5.736s-7.177,4.06-9.683,5.388c-1.253.663-2.273,1.189-2.985,1.539a5.7,5.7,0,0,1-1.129.5,5.541,5.541,0,0,1,1.033-.677l2.9-1.684,9.6-5.515,9.549-5.6,2.9-1.686A5.682,5.682,0,0,1,925.751,413.862Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M923.406,393.649a5.155,5.155,0,0,1-.944.7c-.625.425-1.541,1.022-2.681,1.748-2.279,1.449-5.459,3.4-9.024,5.474s-6.842,3.862-9.231,5.122c-1.2.63-2.168,1.129-2.847,1.461a5.145,5.145,0,0,1-1.079.471,5.137,5.137,0,0,1,.982-.649l2.766-1.605,9.148-5.25,9.093-5.339,2.766-1.605A5.094,5.094,0,0,1,923.406,393.649Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M923.007,374.506a56.951,56.951,0,0,1-9.573,5.18,57.045,57.045,0,0,1,9.573-5.18Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M863.051,404.75a11.576,11.576,0,0,1-1.449,1.012c-.952.62-2.342,1.5-4.071,2.565-3.457,2.134-8.276,5.012-13.635,8.125s-10.252,5.868-13.82,7.811c-1.783.973-3.236,1.744-4.247,2.263a11.392,11.392,0,0,1-1.6.756,11.522,11.522,0,0,1,1.5-.933l4.164-2.407L843.635,416l13.706-7.991,4.155-2.422A11.4,11.4,0,0,1,863.051,404.75Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M878.8,374.55a11.5,11.5,0,0,1-1.448,1.012c-.952.62-2.342,1.5-4.072,2.565-3.457,2.134-8.275,5.012-13.634,8.125s-10.253,5.868-13.821,7.811c-1.783.974-3.235,1.744-4.246,2.263a11.367,11.367,0,0,1-1.6.756,11.6,11.6,0,0,1,1.5-.933l4.164-2.407,13.739-7.94,13.707-7.991,4.155-2.422A11.434,11.434,0,0,1,878.8,374.55Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M893.053,344.561a11.433,11.433,0,0,1-1.449,1.012c-.952.62-2.341,1.5-4.071,2.565-3.457,2.135-8.276,5.012-13.635,8.126s-10.252,5.867-13.82,7.811c-1.783.973-3.236,1.744-4.246,2.263a11.423,11.423,0,0,1-1.6.756,11.4,11.4,0,0,1,1.5-.934l4.164-2.406,13.739-7.941,13.706-7.991c1.7-.989,3.1-1.807,4.155-2.422A11.549,11.549,0,0,1,893.053,344.561Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M908.2,315.524a11.67,11.67,0,0,1-1.449,1.012c-.952.62-2.342,1.5-4.071,2.565-3.458,2.134-8.276,5.012-13.635,8.125s-10.253,5.868-13.821,7.811c-1.783.974-3.235,1.744-4.246,2.263a11.362,11.362,0,0,1-1.6.756,11.591,11.591,0,0,1,1.5-.933l4.163-2.407,13.739-7.94,13.707-7.991,4.155-2.422A11.4,11.4,0,0,1,908.2,315.524Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M964.04,348.674a5.3,5.3,0,0,1-.485.731,20.618,20.618,0,0,1-1.547,1.988,31.824,31.824,0,0,1-6.991,6.059,34.036,34.036,0,0,1-12.8,4.895,31.285,31.285,0,0,1-8.133.238,41.5,41.5,0,0,1-8.525-1.871c-5.693-1.838-10.858-4.226-15.788-5.7a33.935,33.935,0,0,0-13.446-1.542,19.449,19.449,0,0,0-8.608,2.909,15.807,15.807,0,0,0-1.97,1.533,5.715,5.715,0,0,1-.668.569,5.481,5.481,0,0,1,.6-.645,13.57,13.57,0,0,1,1.928-1.625,19.121,19.121,0,0,1,8.681-3.107,33.787,33.787,0,0,1,13.625,1.449c4.978,1.46,10.159,3.84,15.808,5.662a41.513,41.513,0,0,0,8.419,1.859,31.017,31.017,0,0,0,8.006-.2,34.191,34.191,0,0,0,12.674-4.732,33.271,33.271,0,0,0,7.036-5.882c.747-.793,1.258-1.467,1.614-1.916A5.836,5.836,0,0,1,964.04,348.674Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M943.3,301.681a8,8,0,0,1-1.154.91c-.757.566-1.9,1.322-3.351,2.193a55.29,55.29,0,0,1-5.261,2.769,56.928,56.928,0,0,1-13.875,4.335,55.27,55.27,0,0,1-5.9.719c-1.688.109-3.058.139-4,.1a7.861,7.861,0,0,1-1.467-.091,7.969,7.969,0,0,1,1.464-.112c.941-.027,2.3-.113,3.976-.268s3.66-.423,5.845-.824a61.9,61.9,0,0,0,13.765-4.3c2.024-.914,3.812-1.818,5.273-2.651s2.633-1.529,3.423-2.042A7.971,7.971,0,0,1,943.3,301.681Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M888.63,421.62a7.209,7.209,0,0,1-1.033-.875l-2.74-2.453a111.264,111.264,0,0,0-9.522-7.489,30.422,30.422,0,0,0-5.764-3.257,16,16,0,0,0-5.223-1.22,14.262,14.262,0,0,0-4.912.664c-.007-.016.1-.077.306-.177a7.112,7.112,0,0,1,.941-.364,11.2,11.2,0,0,1,3.679-.491,15.655,15.655,0,0,1,5.388,1.142,29.305,29.305,0,0,1,5.881,3.274,88.669,88.669,0,0,1,9.472,7.644c1.142,1.061,2.033,1.952,2.635,2.582A6.287,6.287,0,0,1,888.63,421.62Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M971.851,440.317c.012.013-.107.134-.344.352s-.581.55-1.067.923a28.35,28.35,0,0,1-4.329,2.866,30.628,30.628,0,0,1-32.57-1.985,28.277,28.277,0,0,1-3.948-3.37c-.438-.429-.733-.806-.948-1.045a1.764,1.764,0,0,1-.3-.392,17.756,17.756,0,0,1,1.388,1.292,32.826,32.826,0,0,0,4.017,3.212,31.127,31.127,0,0,0,32.187,1.962,32.8,32.8,0,0,0,4.377-2.7A17.8,17.8,0,0,1,971.851,440.317Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1009.6,498.9s-.125-.137-.349-.419l-.981-1.257a39.132,39.132,0,0,0-4.1-4.541l-1.573-1.4-.847-.752-.955-.706-2.033-1.5-2.325-1.433a47.37,47.37,0,0,0-11.787-4.918,45.241,45.241,0,0,0-15.389-1.343,41.868,41.868,0,0,0-16.861,5.222c-5.466,3.105-10.57,7.337-16.016,11.5a83.876,83.876,0,0,1-8.645,5.929,38.387,38.387,0,0,1-9.96,4.187,33.889,33.889,0,0,1-10.771.871,48.265,48.265,0,0,1-10.308-1.962,103.332,103.332,0,0,1-18.188-7.8c-5.6-2.893-10.89-5.7-16.071-7.809a53.8,53.8,0,0,0-14.944-4.017,36.552,36.552,0,0,0-12.7.959,26.915,26.915,0,0,0-8.768,3.944,23.471,23.471,0,0,0-4.494,4.121l-.954,1.275c-.218.286-.341.426-.341.426s.093-.159.3-.456l.916-1.311a22.632,22.632,0,0,1,4.459-4.22,26.828,26.828,0,0,1,8.81-4.06,36.617,36.617,0,0,1,12.809-1.045,53.9,53.9,0,0,1,15.073,3.984c5.214,2.1,10.527,4.9,16.127,7.782a103.408,103.408,0,0,0,18.113,7.735,47.876,47.876,0,0,0,10.2,1.936,33.436,33.436,0,0,0,10.606-.86,37.931,37.931,0,0,0,9.826-4.13,83.576,83.576,0,0,0,8.6-5.887c5.437-4.151,10.567-8.394,16.089-11.516a38.48,38.48,0,0,1,4.214-2.052c.713-.294,1.409-.621,2.124-.88l2.164-.679a42.874,42.874,0,0,1,8.56-1.623,45.431,45.431,0,0,1,15.518,1.417,47.3,47.3,0,0,1,11.842,5.024l2.328,1.46,2.033,1.53.953.718.845.765,1.565,1.422a36.568,36.568,0,0,1,4.041,4.623q.608.831.942,1.291C1009.506,498.747,1009.6,498.9,1009.6,498.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M985.551,544.509a1.977,1.977,0,0,1-.484.2l-1.422.488a22.358,22.358,0,0,1-2.283.671c-.9.221-1.917.522-3.072.71l-1.8.337c-.628.113-1.291.171-1.972.263-1.362.2-2.831.268-4.375.367a55.006,55.006,0,0,1-19.824-2.842c-1.454-.528-2.846-1-4.1-1.581-.628-.28-1.247-.522-1.819-.807l-1.636-.83c-1.056-.5-1.947-1.079-2.749-1.545a22.089,22.089,0,0,1-2-1.285l-1.228-.867a.264.264,0,1,1,.06-.086l1.278.783c.546.353,1.221.772,2.039,1.2s1.709.988,2.768,1.467l1.64.795c.571.273,1.19.5,1.817.773,1.247.557,2.634,1.012,4.079,1.523a56.987,56.987,0,0,0,19.656,2.818c1.531-.085,2.989-.131,4.343-.316.677-.082,1.335-.13,1.96-.231l1.8-.3c1.152-.163,2.167-.437,3.07-.631s1.671-.4,2.295-.582l1.447-.393A2.012,2.012,0,0,1,985.551,544.509Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M382.821,477.432a5.637,5.637,0,0,1-1.082.606c-.711.36-1.749.861-3.038,1.466-2.578,1.21-6.167,2.822-10.17,4.514s-7.662,3.143-10.326,4.149c-1.332.5-2.414.9-3.168,1.157a5.694,5.694,0,0,1-1.189.354,5.659,5.659,0,0,1,1.116-.543l3.105-1.31,10.26-4.287,10.221-4.37,3.105-1.314A5.613,5.613,0,0,1,382.821,477.432Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M399.093,447.486a10.575,10.575,0,0,1-1.506.8c-.985.48-2.42,1.154-4.2,1.966-3.564,1.626-8.521,3.8-14.025,6.125s-10.519,4.368-14.169,5.792c-1.825.713-3.308,1.272-4.339,1.644a10.545,10.545,0,0,1-1.621.525,10.785,10.785,0,0,1,1.547-.713l4.274-1.8,14.105-5.93,14.079-5.982L397.5,448.1A10.762,10.762,0,0,1,399.093,447.486Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M418.962,420.784a11.407,11.407,0,0,1-1.577.8c-1.03.481-2.529,1.156-4.391,1.967-3.723,1.627-8.9,3.8-14.642,6.127s-10.976,4.368-14.782,5.79c-1.9.713-3.449,1.272-4.522,1.644a11.344,11.344,0,0,1-1.688.523,11.6,11.6,0,0,1,1.616-.713l4.461-1.8,14.719-5.929,14.694-5.984L417.3,421.4A11.605,11.605,0,0,1,418.962,420.784Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M498.553,451.624a5.6,5.6,0,0,1-1.087.587c-.713.348-1.754.831-3.046,1.414-2.585,1.166-6.181,2.72-10.192,4.345s-7.677,3.011-10.345,3.972c-1.334.481-2.417.858-3.171,1.105a5.6,5.6,0,0,1-1.189.334,5.725,5.725,0,0,1,1.118-.524l3.112-1.259,10.28-4.11,10.241-4.2,3.111-1.262A5.658,5.658,0,0,1,498.553,451.624Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M495.32,506.562a5.309,5.309,0,0,1-1.05.586c-.691.348-1.7.831-2.95,1.413-2.5,1.166-5.988,2.72-9.876,4.344s-7.444,3.012-10.032,3.974c-1.294.481-2.346.858-3.078,1.1a5.406,5.406,0,0,1-1.155.336,5.294,5.294,0,0,1,1.082-.525l3.017-1.259,9.966-4.111,9.926-4.2,3.016-1.261A5.314,5.314,0,0,1,495.32,506.562Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M494.857,525.817a5.335,5.335,0,0,1-1.05.587c-.691.347-1.7.83-2.95,1.413-2.5,1.165-5.988,2.719-9.876,4.344s-7.444,3.011-10.032,3.973c-1.294.481-2.346.859-3.078,1.106a5.356,5.356,0,0,1-1.155.335,5.264,5.264,0,0,1,1.082-.524l3.017-1.26,9.966-4.111,9.926-4.2,3.016-1.261A5.386,5.386,0,0,1,494.857,525.817Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M494.394,545.073a5.374,5.374,0,0,1-1.05.586c-.69.347-1.7.83-2.95,1.413-2.5,1.165-5.988,2.719-9.875,4.344s-7.445,3.011-10.033,3.973c-1.294.481-2.346.859-3.078,1.106a5.268,5.268,0,0,1-1.155.335,5.389,5.389,0,0,1,1.083-.524l3.016-1.259,9.966-4.112,9.927-4.2,3.015-1.261A5.337,5.337,0,0,1,494.394,545.073Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M499.074,431.282a5.69,5.69,0,0,1-1.087.587c-.713.347-1.754.831-3.047,1.414-2.584,1.166-6.181,2.72-10.191,4.345s-7.677,3.011-10.345,3.972c-1.334.481-2.418.858-3.172,1.1a5.607,5.607,0,0,1-1.188.334,5.624,5.624,0,0,1,1.117-.524l3.112-1.259,10.28-4.111,10.242-4.2,3.111-1.262A5.634,5.634,0,0,1,499.074,431.282Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M499.594,410.94a5.675,5.675,0,0,1-1.087.587c-.713.347-1.754.83-3.046,1.414-2.585,1.166-6.181,2.72-10.192,4.345s-7.677,3.01-10.345,3.972c-1.334.48-2.417.858-3.171,1.1a5.6,5.6,0,0,1-1.189.335,5.578,5.578,0,0,1,1.118-.525l3.112-1.258,10.28-4.111,10.241-4.2,3.111-1.261A5.581,5.581,0,0,1,499.594,410.94Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M500.114,390.6a5.089,5.089,0,0,1-1.033.564c-.678.333-1.669.795-2.9,1.353-2.461,1.115-5.884,2.6-9.705,4.151s-7.317,2.861-9.86,3.773c-1.272.455-2.3.813-3.024,1.046a5.1,5.1,0,0,1-1.134.314,5.147,5.147,0,0,1,1.064-.5l2.964-1.2,9.794-3.91,9.755-4.007,2.964-1.2A5.146,5.146,0,0,1,500.114,390.6Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M502.413,371.588a56.945,56.945,0,0,1-10.207,3.783,57.145,57.145,0,0,1,10.207-3.783Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M438.8,393.1a11.27,11.27,0,0,1-1.576.8c-1.03.48-2.53,1.155-4.392,1.967-3.723,1.627-8.9,3.8-14.642,6.127s-10.976,4.368-14.782,5.79c-1.9.713-3.448,1.271-4.522,1.643a11.349,11.349,0,0,1-1.687.524,11.459,11.459,0,0,1,1.616-.713l4.46-1.8,14.72-5.93,14.694-5.983,4.454-1.814A11.5,11.5,0,0,1,438.8,393.1Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M458.635,365.414a11.554,11.554,0,0,1-1.577.8c-1.03.48-2.529,1.155-4.391,1.967-3.723,1.627-8.9,3.8-14.642,6.127s-10.976,4.367-14.782,5.79c-1.9.712-3.449,1.271-4.522,1.643a11.294,11.294,0,0,1-1.688.524,11.51,11.51,0,0,1,1.616-.714l4.461-1.8,14.719-5.929,14.694-5.983,4.455-1.814A11.447,11.447,0,0,1,458.635,365.414Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M476.968,337.729a11.549,11.549,0,0,1-1.577.8c-1.03.48-2.529,1.155-4.392,1.967-3.723,1.627-8.9,3.8-14.642,6.127s-10.975,4.367-14.781,5.789c-1.9.713-3.449,1.272-4.523,1.644a11.581,11.581,0,0,1-1.687.524,11.51,11.51,0,0,1,1.616-.714l4.461-1.8,14.719-5.929,14.694-5.984,4.454-1.813A11.475,11.475,0,0,1,476.968,337.729Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M496.043,311.11a11.638,11.638,0,0,1-1.577.8c-1.03.481-2.529,1.156-4.392,1.967-3.723,1.627-8.9,3.8-14.642,6.127s-10.975,4.368-14.781,5.79c-1.9.713-3.449,1.272-4.523,1.644a11.629,11.629,0,0,1-1.687.524,11.358,11.358,0,0,1,1.616-.714l4.461-1.8,14.719-5.929,14.694-5.984,4.454-1.813A11.324,11.324,0,0,1,496.043,311.11Z",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M546.671,351.785a5.563,5.563,0,0,1-.584.655,20.347,20.347,0,0,1-1.811,1.751,31.828,31.828,0,0,1-7.773,5.015,34.025,34.025,0,0,1-13.358,3.047,31.265,31.265,0,0,1-8.086-.909,41.472,41.472,0,0,1-8.177-3.051c-5.377-2.62-10.156-5.711-14.829-7.863a33.939,33.939,0,0,0-13.1-3.417,19.436,19.436,0,0,0-8.932,1.669,15.648,15.648,0,0,0-2.166,1.241,5.482,5.482,0,0,1-.742.469,5.567,5.567,0,0,1,.681-.555,13.531,13.531,0,0,1,2.138-1.337,19.126,19.126,0,0,1,9.032-1.855,33.8,33.8,0,0,1,13.286,3.35c4.723,2.146,9.518,5.231,14.854,7.829a41.435,41.435,0,0,0,8.074,3.025,31.046,31.046,0,0,0,7.955.924,34.177,34.177,0,0,0,13.214-2.9,33.265,33.265,0,0,0,7.792-4.833c.852-.68,1.452-1.275,1.869-1.67A5.605,5.605,0,0,1,546.671,351.785Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M532.744,302.342a8.1,8.1,0,0,1-1.271.738c-.829.454-2.067,1.042-3.626,1.7a55.4,55.4,0,0,1-5.6,2,57,57,0,0,1-14.347,2.34,55.088,55.088,0,0,1-5.944-.119c-1.687-.129-3.047-.292-3.978-.459a7.946,7.946,0,0,1-1.439-.3,7.881,7.881,0,0,1,1.465.1c.935.105,2.295.212,3.974.293s3.683.1,5.9.007a62,62,0,0,0,14.232-2.322c2.133-.62,4.031-1.264,5.6-1.882s2.821-1.145,3.675-1.542A7.934,7.934,0,0,1,532.744,302.342Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M461.751,413.4a7.08,7.08,0,0,1-.9-1.011l-2.368-2.815a111.435,111.435,0,0,0-8.374-8.753,30.486,30.486,0,0,0-5.248-4.036,16,16,0,0,0-5-1.941,14.262,14.262,0,0,0-4.957-.034c-.005-.018.108-.062.328-.132a6.976,6.976,0,0,1,.983-.229,11.222,11.222,0,0,1,3.712.032,15.666,15.666,0,0,1,5.173,1.888,29.3,29.3,0,0,1,5.362,4.069,88.731,88.731,0,0,1,8.3,8.9c.981,1.211,1.738,2.219,2.245,2.927A6.518,6.518,0,0,1,461.751,413.4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M541.515,443.615a1.77,1.77,0,0,1-.39.3c-.27.175-.653.462-1.187.763a28.29,28.29,0,0,1-4.689,2.228,30.627,30.627,0,0,1-31.966-6.545,28.212,28.212,0,0,1-3.435-3.893c-.373-.486-.613-.9-.792-1.167a1.763,1.763,0,0,1-.24-.43,17.427,17.427,0,0,1,1.192,1.474,33.015,33.015,0,0,0,3.525,3.746,31.133,31.133,0,0,0,31.592,6.469,32.851,32.851,0,0,0,4.713-2.059A17.671,17.671,0,0,1,541.515,443.615Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M570.651,506.93s-.1-.154-.287-.464l-.8-1.383a39.022,39.022,0,0,0-3.419-5.072q-.645-.76-1.36-1.6l-.733-.864-.846-.832-1.8-1.775-2.1-1.745a47.382,47.382,0,0,0-10.978-6.528,45.272,45.272,0,0,0-15.047-3.493,41.839,41.839,0,0,0-17.428,2.8c-5.848,2.3-11.5,5.776-17.475,9.136a83.654,83.654,0,0,1-9.393,4.654,38.35,38.35,0,0,1-10.45,2.745,33.884,33.884,0,0,1-10.786-.652,48.306,48.306,0,0,1-9.93-3.393,103.342,103.342,0,0,1-16.911-10.278c-5.135-3.652-9.979-7.175-14.812-9.992a53.788,53.788,0,0,0-14.231-6.079,36.542,36.542,0,0,0-12.708-.836,26.878,26.878,0,0,0-9.236,2.672,23.438,23.438,0,0,0-5.029,3.447l-1.124,1.128c-.255.253-.4.374-.4.374s.115-.144.358-.41l1.091-1.169a22.649,22.649,0,0,1,5.008-3.551,26.857,26.857,0,0,1,9.294-2.781,36.626,36.626,0,0,1,12.828.768,53.878,53.878,0,0,1,14.363,6.064c4.867,2.815,9.733,6.335,14.873,9.973a103.475,103.475,0,0,0,16.845,10.206,47.865,47.865,0,0,0,9.828,3.351,33.407,33.407,0,0,0,10.622.64,37.928,37.928,0,0,0,10.309-2.707,83.485,83.485,0,0,0,9.339-4.619c5.967-3.345,11.643-6.824,17.549-9.138a38.614,38.614,0,0,1,4.46-1.44c.748-.19,1.483-.416,2.227-.572l2.238-.368a42.9,42.9,0,0,1,8.7-.4,45.46,45.46,0,0,1,15.165,3.585,47.341,47.341,0,0,1,11.018,6.64l2.1,1.773,1.8,1.8.842.845.729.876,1.35,1.628a36.618,36.618,0,0,1,3.351,5.145c.322.606.572,1.075.75,1.411C570.578,506.761,570.651,506.93,570.651,506.93Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M540.424,548.7a1.986,1.986,0,0,1-.508.134l-1.476.282a22.2,22.2,0,0,1-2.354.343c-.924.093-1.972.248-3.142.271l-1.834.081c-.637.023-1.3-.013-1.989-.018-1.377.012-2.841-.132-4.383-.252a54.968,54.968,0,0,1-19.227-5.6c-1.365-.728-2.677-1.393-3.833-2.142-.583-.365-1.162-.692-1.687-1.054l-1.5-1.053c-.974-.647-1.775-1.342-2.5-1.915a22.5,22.5,0,0,1-1.8-1.554l-1.093-1.031a2.022,2.022,0,0,1-.357-.385,1.939,1.939,0,0,1,.428.307l1.155.956c.492.426,1.1.936,1.85,1.478s1.553,1.219,2.534,1.843l1.512,1.017c.527.351,1.108.666,1.69,1.021,1.156.727,2.465,1.372,3.825,2.082a56.983,56.983,0,0,0,19.064,5.554c1.527.131,2.978.29,4.343.3.682.014,1.341.059,1.974.047l1.822-.046c1.163,0,2.207-.129,3.128-.193s1.71-.158,2.354-.254l1.488-.186A2.116,2.116,0,0,1,540.424,548.7Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M784.207,220.914q-1.5-6.606,1.342-11.123t9.413-6.01q6.735-1.532,11.2,1.257t5.946,9.3a17.037,17.037,0,0,1,.172,8.119,11.644,11.644,0,0,1-3.53,5.756,15.567,15.567,0,0,1-7.116,3.388,17.69,17.69,0,0,1-7.884.265,11.661,11.661,0,0,1-5.894-3.5A15.664,15.664,0,0,1,784.207,220.914Zm8.344-1.858q.928,4.086,2.853,5.525a5.9,5.9,0,0,0,8.3-1.848q1.074-2.084.045-6.609-.866-3.808-2.8-5.218a5.387,5.387,0,0,0-4.567-.809,5.191,5.191,0,0,0-3.642,2.705Q791.614,214.935,792.551,219.056Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M816.084,217.615a10.029,10.029,0,0,1,1.343-8.056,11.555,11.555,0,0,1,7.493-4.751q5.87-1.333,9.643,1.388a10.913,10.913,0,0,1,2.635,14.273q-2.336,3.56-7.617,4.76a11.893,11.893,0,0,1-8.161-.66A9.85,9.85,0,0,1,816.084,217.615Zm7.5-1.725a6.05,6.05,0,0,0,1.937,3.624,3.555,3.555,0,0,0,5.322-1.191,6.253,6.253,0,0,0,.14-4.192,5.913,5.913,0,0,0-1.908-3.544,3.354,3.354,0,0,0-2.877-.652,3.478,3.478,0,0,0-2.419,1.876A5.985,5.985,0,0,0,823.588,215.89Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M846.076,228.834l-6.133-26.977,7.011-1.6.657,2.889a9.56,9.56,0,0,1,2.107-3.071,7.835,7.835,0,0,1,3.429-1.689,7.193,7.193,0,0,1,6.745,1.62,12.749,12.749,0,0,1,3.83,6.929q1.109,4.876-.645,7.975a7.842,7.842,0,0,1-5.324,3.91,8.428,8.428,0,0,1-3.289.128,7.727,7.727,0,0,1-2.946-1.168l2.121,9.329Zm3.609-18.858a5.277,5.277,0,0,0,1.757,3.22,3.207,3.207,0,0,0,2.721.561,2.792,2.792,0,0,0,1.945-1.574,5.97,5.97,0,0,0,.053-3.853,5.566,5.566,0,0,0-1.713-3.278,2.886,2.886,0,0,0-2.5-.6,3.1,3.1,0,0,0-2.137,1.666A5.735,5.735,0,0,0,849.685,209.976Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M866.926,210.566l7.275-2.39a3.769,3.769,0,0,0,1.719,1.6,3.933,3.933,0,0,0,2.338.068,3.829,3.829,0,0,0,2.191-1.175,1.47,1.47,0,0,0,.372-1.34,1.4,1.4,0,0,0-1.13-1.057,15.887,15.887,0,0,0-3.4-.04,34.47,34.47,0,0,1-5.7-.026,5.886,5.886,0,0,1-3-1.377,5.22,5.22,0,0,1-1.755-2.908,5.28,5.28,0,0,1,.367-3.582,6.848,6.848,0,0,1,2.617-2.79,16.844,16.844,0,0,1,5.124-1.889,18.717,18.717,0,0,1,5.283-.64,6.9,6.9,0,0,1,3.155,1.024,8.881,8.881,0,0,1,2.539,2.617l-6.943,2.314a2.486,2.486,0,0,0-1.234-1.171,3.833,3.833,0,0,0-2.268-.1,3.1,3.1,0,0,0-1.747.87,1.378,1.378,0,0,0-.332,1.225,1.192,1.192,0,0,0,.983.916,12.11,12.11,0,0,0,3.352-.066,22.517,22.517,0,0,1,5.825-.086,6.276,6.276,0,0,1,3.276,1.517,5.421,5.421,0,0,1,1.665,2.85,6.2,6.2,0,0,1-.274,3.523,7.1,7.1,0,0,1-2.641,3.278,15.927,15.927,0,0,1-5.774,2.309q-5.355,1.217-7.975.206A7.043,7.043,0,0,1,866.926,210.566Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M891.34,185.833l8.208-.046.036,6.3-1.513,12.67-5.077.029-1.618-12.653Zm.4,20.889,7.661-.044.039,6.774-7.662.044Z",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Page);
export default __webpack_public_path__ + "static/media/404page.468a0c4e70947ab45da103e6abea34b9.svg";
export { ForwardRef as ReactComponent };